<!-- @format -->

<div
	id="plp-srlp-product-list-header"
	class="hmf-mx-s">
	<!-- breadcrumbs and header -->
	@if (productListSEOData) {
		<div
			[class]="{
				'hmf-display-flex hmf-flex-column hmf-align-items-center hmf-justify-content-center':
					!salesAndDealsContent
			}">
			<plp-components-breadcrumb
				class="plp-breadcrumb hmf-subheader-m hmf-display-flex hmf-pt-m-m hmf-pt-s hmf-pb-xs"
				[breadcrumbsEnabled]="browseBreadcrumbsEnabled()">
			</plp-components-breadcrumb>
			@if (productListData) {
				<h1
					class="heading hmf-header-bold-m hmf-header-bold-lg-l hmf-my-0"
					[class.hmf-pb-s]="!bubbleDetails || isPlp3Template">
					{{ productListSEOData?.name }}
				</h1>
			} @else {
				<ng-container *ngTemplateOutlet="apiErrorMessage"></ng-container>
			}
		</div>
	} @else {
		<div>
			<plp-components-breadcrumb
				class="plp-breadcrumb hmf-subheader-m hmf-display-flex hmf-pt-s hmf-pt-m-m hmf-pb-xs"
				[searchTerm]="productListData?.searchVO?.searchTerm"
				[breadcrumbsEnabled]="browseBreadcrumbsEnabled()"
				[isSearchPage]="true">
			</plp-components-breadcrumb>
			@if (productListData) {
				<div>
					@if (productListData?.fuzzyMatch) {
						<h1
							class="heading hmf-display-flex hmf-header-bold-m hmf-header-bold-m-l hmf-my-0"
							[class]="
								productListData?.didYouMeanVO?.originalSearchTerm
									? 'hmf-mb-xs hmf-mb-m-s'
									: 'hmf-mb-s hmf-mb-m-m'
							">
							{{ fuzzySearchResultHeader }}
						</h1>
					} @else {
						<h1
							class="heading hmf-display-flex hmf-header-bold-m hmf-header-bold-m-l hmf-my-0"
							[class]="
								productListData?.didYouMeanVO?.originalSearchTerm
									? 'hmf-mb-xs hmf-mb-m-s'
									: 'hmf-mb-s hmf-mb-m-m'
							">
							{{ productListData?.searchVO?.totalCount || 'No' }} results for "{{
								productListData?.searchVO?.searchTerm || ''
							}}"
						</h1>
					}
					@if (productListData?.fuzzyMatch && productListData?.totalCount > 0) {
						<p class="search-msg hmf-mb-s hmf-mb-m-m hmf-subheader-m">
							We couldn’t find results for "{{
								productListData?.searchVO?.searchTerm
							}}" right now.
							{{
								chainAbbr === 'pl' || chainAbbr === 'gg'
									? 'You might like these items instead!'
									: 'Try these instead.'
							}}
						</p>
					}
					@if (productListData?.didYouMeanVO && !productListData?.mlBypass) {
						<p class="search-msg hmf-mb-s hmf-mb-m-m hmf-subheader-m">
							Search instead for
							<button
								hmf-action-text
								variant="secondary"
								(click)="searchInstead()">
								{{ productListData?.didYouMeanVO.originalSearchTerm }}
							</button>
						</p>
					}
					@if (productListData?.totalCount === 0) {
						<div class="no-results-msg hmf-mb-s hmf-mb-m-m hmf-subheader-s">
							<p>We're sorry, we did not find any matches.</p>
							<p>
								Please check for any spelling errors or try more general keywords.
							</p>
						</div>
					}
				</div>
			} @else {
				<ng-container *ngTemplateOutlet="apiErrorMessage"></ng-container>
			}
		</div>
	}
</div>

<ng-template #apiErrorMessage>
	<div class="heading hmf-display-flex hmf-header-bold-m hmf-header-bold-m-l hmf-my-0">
		<p>Something went wrong. Please try again.</p>
	</div>
</ng-template>
@if (narrowBanner()) {
	<shared-components-google-ad-manager
		[data]="'top_narrow_banner'"
		[showSponsoredLabel]="true"
		[enableAdCarousel]="true"
		[isNarrowBanner]="true"
		[enableTooltipSurvey]="enableTooltipSurvey()">
	</shared-components-google-ad-manager>
}

<!-- superfamily bubbles -->
@if (productListSEOData && bubbleDetails && !isPlp3Template) {
	<div
		id="superfamily-bubbles-container"
		class="superfamily-bubbles-container hmf-align-items-center hmf-display-flex hmf-justify-content-center hmf-mt-s hmf-position-relative">
		<shared-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-ml-xs hmf-ml-md-s carousel-button prev"
			[class.hmf-display-block]="showLeftArrow"
			[previous]="true"
			[ariaLabel]="'Previous Category'"
			[showLeftArrow]="showLeftArrow"
			(clickEvent)="clickBubblesCarouselButton($event)">
		</shared-components-carousel-button>
		<div
			#bubbleWrapper
			id="bubbles-wrapper"
			class="bubble-container hmf-display-flex hmf-pb-xxs hmf-px-s hmf-px-md-m hmf-pb-md-xs"
			[class.bubbles-wrapper-content-center]="!scrollEnabled"
			(scroll)="recalculateArrows()">
			@if (salesAndDealsContent && shopAllCategoryBubbleEnabled()) {
				<plp-components-category-bubble
					[image]="'https://images.dickssportinggoods.com/assets/icons/dsg/SaleIcon.png'"
					[link]="'#'"
					[altText]="'Shop All Button'"
					[label]="'Shop All'"
					[attr.data-em]="'LN_Bubble_ShopAll'"
					tabindex="0"
					(keydown.enter)="scrollToProductGrid()"
					(click)="scrollToProductGrid()"></plp-components-category-bubble>
			}

			@for (bubble of bubbleDetails; track trackByFn($index, bubble)) {
				<plp-components-category-bubble
					[image]="bubble.imgSrc"
					[link]="bubble.url"
					[altText]="bubble.name"
					[label]="bubble.name"
					[attr.data-em]="bubble.dataEmAttr"></plp-components-category-bubble>
			}
		</div>
		<shared-components-carousel-button
			class="hmf-position-absolute hmf-display-none hmf-mr-xs hmf-mr-md-s carousel-button next"
			[class.hmf-display-block]="showRightArrow"
			[previous]="false"
			[ariaLabel]="'Next Category'"
			[showRightArrow]="showRightArrow"
			(clickEvent)="clickBubblesCarouselButton($event)">
		</shared-components-carousel-button>
	</div>
}
